var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticStyle:{"padding":"1px","background-color":"#e7edf5"}},[(_vm.legs === 1)?_c('b-form-select',{staticStyle:{"border":"1px solid gray"},attrs:{"options":_vm.options,"size":"sm"},model:{value:(_vm.stockGraphType),callback:function ($$v) {_vm.stockGraphType=$$v},expression:"stockGraphType"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }